import React, { Component } from 'react';
import { CSItemInfo } from './componentChildren/CSItemInfo';
import { SOPZone } from './componentChildren/SOPZone';
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import { SlotSummary } from './componentChildren/SlotSummary';
import { UserInstructions } from './componentChildren/UserInstructions';
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ScannedItemsCart } from './componentChildren/ScannedItemsCart';

export class GMPicking extends Component {

    constructor(props) {
        super(props);
        this.getLineStatus = this.getLineStatus.bind(this);
        this.getZoneStatus = this.getZoneStatus.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.isPicked = this.isPicked.bind(this)
        this.sortItemsByZone = this.sortItemsByZone.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;

        this.props.updateScanItem(value);
    }

    getZoneStatus(items) {
        var hasIncomplete = false;
        var hasComplete = false;
        var hasPartial = false;
        for (var i in items) {
            if (this.isPicked(items[i]) || items[i].isBackordered || items[i].pickLater) {
                hasComplete = true;
            }
            else if (items[i].quantityPicked === 0) {
                hasIncomplete = true;
            }
            else {
                hasPartial = true;
            }
        }
        if (hasIncomplete && !hasComplete && !hasPartial) {
            return "zone-toPick"
        }
        else if (hasComplete && !hasIncomplete && !hasPartial) {
            return "zone-complete";
        }
        else {
            return "zone-partial";
        }
    }

    getLineStatus(item) {
        if (item.qtyCancelled > 0) {
            return "itemInfo canceled"
        }
        else if (item.doSubstitution) {
            return "itemInfo subbed";
        }
        else if (item.isBackordered) {
            return "itemInfo bo"
        }
        else if(this.isPicked(item)) {
            return "itemInfo complete"
        }
        else if (item.quantityPicked === 0) {
            if (item.pickLater) {
                return "itemInfo pickLater"
            }
            else {
                return "itemInfo toPick"
            }
        }
        else {
            return "itemInfo partial"
        }
    }

    isPicked(item) {
        var isPicked = false;
        if (item.quantity == 0) {
            if(item.needsSerialNum) {
                if (item.serialNum) {
                    isPicked = true;
                }
            }
            else if (item.isGiftCard) {
                if (item.giftCardNum) {
                    isPicked = true;
                }
                //In case an item has both
                else {
                    isPicked = false;
                }
            }
            else {
                isPicked = true;
            }
        }
        return isPicked;
    }

    sortItemsByZone(itemsToPick,itemInfo) {
        var zones = {};
        var itemsToPickCopy = JSON.parse(JSON.stringify(itemsToPick));
        if (this.props.reverseSort) {
            itemsToPickCopy = itemsToPickCopy.reverse();
        }
        for (var i in itemsToPickCopy) {
            var itemId = itemsToPickCopy[i].itemId;
            var binIndex = itemInfo[itemId].binIndex;
            var pickingOrder = itemInfo[itemId].bins[binIndex].pickingOrder;
            var zoneName = itemInfo[itemId].bins[binIndex].zoneName;
            if (itemsToPickCopy[i].qtyCancelled > 0) {
                if (!zones["canceled"]) {
                    zones["canceled"] = {
                        zoneName: "Canceled Items",
                        items: [],
                        pickingOrder: 10000004
                    };
                }
                zones["canceled"].items.push(itemsToPickCopy[i]);
            }
            else if (itemsToPickCopy[i].isBackordered) {
                if (!zones["backordered"]) {
                    zones["backordered"] = {
                        zoneName: "Backordered",
                        items: [],
                        pickingOrder: 10000003
                    };
                }
                zones["backordered"].items.push(itemsToPickCopy[i]);

            }
            else if (this.isPicked(itemsToPickCopy[i])) {
                if (!zones["processed"]) {
                    zones["processed"] = {
                        zoneName: "Picked Items",
                        items: [],
                        pickingOrder: 10000001
                    };
                }
                zones["processed"].items.push(itemsToPickCopy[i]);
            }
            else if (itemsToPickCopy[i].pickLater) {
                if (!zones["pickLater"]) {
                    zones["pickLater"] = {
                        zoneName: "Pick Later",
                        items: [],
                        pickingOrder: 10000002
                    };
                }
                zones["pickLater"].items.push(itemsToPickCopy[i]);
            }
            else {
                if (!zones[pickingOrder]) {
                    if (!zoneName || zoneName === "none") {
                        pickingOrder = "0-none";
                        zoneName = "No Zone Available";
                    }
                    zones[pickingOrder] = {
                        zoneName: zoneName,
                        items: [],
                        pickingOrder: pickingOrder
                    };
                }
                zones[pickingOrder].items.push(itemsToPickCopy[i]);
            } 
        }
        var zonesArray = [];
        for (var key in zones) {
            zonesArray.push(zones[key])
        }
        zonesArray = zonesArray.sort((a, b) => (parseInt(a.pickingOrder) > parseInt(b.pickingOrder)) ? 1 : -1)
        return zonesArray;
    }

    render() {
        var itemInfo = this.props.itemInfo;
        var getLineStatusFunction = this.getLineStatus;
        var doNotPickFunction = this.props.doNotPick;
        var backorderFunction = this.props.backorderItem;
        var pickNowFunction = this.props.pickNow;
        var changeBinFunction = this.props.changeBin;
        var showImageFunction = this.props.showImage;
        var cancelItemFunction = this.props.cancelItem;
        var undoCancelFunction = this.props.undoCancel;
        var undoBackorderFunction = this.props.undoBackorder;
        var undoPickFunction = this.props.undoPick;
        var toggleSortByLengthFunction = this.props.toggleSortByLength;
        var additionalInfoOptions = this.props.additionalInfoOptions;
        var editInputField = this.props.editInputField
        var updateGiftCardNum = this.props.updateGiftCardNum;
        var updateSerialNum = this.props.updateSerialNum;
        var canCancel = this.props.canCancel;
        var canBackorder = this.props.canBackorder;
        var canEditQty = this.props.canEditQty
        var multiScanThreshold = this.props.multiScanThreshold;
        var updateQuantityFunction = this.props.updateQuantity;
        var startBinQtyEditFunction = this.props.startBinQtyEdit;
        var location = this.props.location;
        var itemsToPick = location.usesBins ?
            this.sortItemsByZone(
                this.props.sortItems(this.props.itemsToPick, itemInfo),
                itemInfo
            ): this.props.itemsToPick;
        var getZoneStatus = this.getZoneStatus;
        var activeZone = this.props.activeZone;
        var sortBy = this.props.sortBy;
        var sortByFields = this.props.sortByFields;
        return (
            <div>
                <div className="stickyHeader">
                    <div>
                        <div className="sessionInfo">
                            {
                                this.props.requireSlotScan
                                &&
                                (
                                    <div>
                                        <input type="checkbox" checked={this.props.putawayMode} onClick={this.props.changePutawayMode} id="putawayMode" name="putaway_mode" />
                                        <label htmlFor="putawayMode">Putaway Now</label>
                                    </div>
                                )
                            }
                            <b>Location: {location.locationName}</b>
                        </div>
                        
                        <div className="sessionButtons">
                            <button onClick={
                                this.props.pickFromScannedItemsCart ? () => this.props.endPutAway() : () => this.props.startPutAway() 
                             }
                            >{this.props.pickFromScannedItemsCart ? "Pick Items" : "Put Away"}</button>
                            {location.usesBins && <button onClick={this.props.flipOrder}>Flip Order</button>}
                            {!location.usesBins && sortByFields.length > 1 && <button onClick={this.props.changeSortBy}>Change Sort</button>}
                        </div>
                    </div>
                    <div className="sessionActions">
                        <button onClick={() => this.props.cancelSession()}>Cancel</button>
                        <form className="scanItemForm" action="#" onSubmit={this.props.processGMPickingInput}>
                            <input className="scanItemInput" autoComplete="off" type="text" id="scanInput" name="itemInput" placeholder="Scan or Enter Item UPC" value={this.props.scannedItemInput} onChange={this.handleInputChange}></input>
                        </form>
                        <button onClick={() => this.props.submitPicking()}>Submit</button>
                    </div>
                    <UserInstructions
                        instructions={this.props.instructions}
                        activeSlot={this.props.activeSlot}
                    />
                </div>
                <br />
                {
                    itemsToPick.length == 0
                    && 
                    <h1>These orders are all fully fulfilled!. Submit to bill those orders.</h1>
                }
                {
                    this.props.pickFromScannedItemsCart ?
                        <ScannedItemsCart
                            undoPick={undoPickFunction}
                            scannedItemsCart={this.props.scannedItemsCart}
                            endPutAway={this.props.endPutAway}
                            usesBins={location.usesBins}
                    />
                    :
                    <div>
                        {
                            !location.usesBins
                            &&
                            itemsToPick.map(function (element, idx) {  
                                return (
                                    <div key={"CS"+idx}>
                                        <CSItemInfo
                                            item={element}
                                            itemInfo={itemInfo}
                                            getLineStatus={getLineStatusFunction}
                                            doNotPick={doNotPickFunction}
                                            backorderItem={backorderFunction}
                                            location={location.locationId}
                                            showImage={showImageFunction}
                                            additionalInfoOptions={additionalInfoOptions}
                                            editInputField={editInputField}
                                            updateGiftCardNum={updateGiftCardNum}
                                            updateSerialNum={updateSerialNum}
                                            canCancel={canCancel}
                                            canBackorder={canBackorder}
                                            canEditQty={canEditQty}
                                            cancelItem={cancelItemFunction}
                                            undoCancel={undoCancelFunction}
                                            undoBackorder={undoBackorderFunction}
                                            sortBy={sortBy}
                                            sortByFields={sortByFields}
                                            toggleSortByLength={toggleSortByLengthFunction}
                                            multiScanThreshold={multiScanThreshold}
                                            startBinQtyEdit={startBinQtyEditFunction}
                                        />
                                    </div>
                                )   
                            })
                        }
                        {
                            location.usesBins
                            &&
                            <Accordion allowZeroExpanded onChange={(activatedZone) => this.props.changeZone(activatedZone[0])}>
                                {
                                    itemsToPick.map(function (element, idx) {
                                        var zoneStatus = getZoneStatus(element.items);
                                        return (
                                            <div>
                                                <AccordionItem key={"A"+element.zoneName} uuid={element.pickingOrder} className={zoneStatus}>
                                                    <AccordionItemHeading className="accordion-heading">
                                                        <AccordionItemButton>
                                                            <h1><FontAwesomeIcon icon={activeZone === element.pickingOrder ? faCaretDown : faCaretRight} /> {element.zoneName} </h1>
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <SOPZone
                                                            zoneItems={element.items}
                                                            itemInfo={itemInfo}
                                                            getLineStatus={getLineStatusFunction}
                                                            doNotPick={doNotPickFunction}
                                                            backorderItem={backorderFunction}
                                                            pickNow={pickNowFunction}
                                                            changeBin={changeBinFunction}
                                                            zone={idx}
                                                            zoneName={element.zoneName}
                                                            location={location.locationId}
                                                            additionalInfoOptions={additionalInfoOptions}
                                                            editInputField={editInputField}
                                                            updateGiftCardNum={updateGiftCardNum}
                                                            updateSerialNum={updateSerialNum}
                                                            canCancel={canCancel}
                                                            canBackorder={canBackorder}
                                                            canEditQty={canEditQty}
                                                            cancelItem={cancelItemFunction}
                                                            undoCancel={undoCancelFunction}
                                                            undoBackorder={undoBackorderFunction}
                                                            multiScanThreshold={multiScanThreshold}
                                                            updateQuantity={updateQuantityFunction}
                                                            startBinQtyEdit={startBinQtyEditFunction}
                                                        />
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                                <br/>
                                            </div>
                                        )
                                    })
                                }
                            </Accordion>
                        }
                    </div>
                }
                <br />
                <br />
                <SlotSummary
                    slotList={this.props.slotList}
                />
            </div>
        );
    }
}
